import { ITooltip, Tooltip } from 'react-tooltip';

type TooltipProps = ITooltip & {
	elementID: string;
}

export default function CustomTooltip(props: TooltipProps) {
	const { elementID, place = 'bottom', ...other } = props;
	return <Tooltip {...other} anchorSelect={`#${elementID}`} 
		style={{ fontSize: '12px', zIndex: '10' }} offset={6} place={place}/>;
}